import * as React from "react";
import { useContext } from "react";
import { useWindowSize } from "react-use";
import styled, { css } from "styled-components";
import { Link, useConfig } from "docz";

import { Hamburguer } from "@components/shared/Sidebar/Hamburguer";
import { breakpoints } from "@styles/responsive";
import pageConfig from "../../../../../doc.json";
import { mainContext } from "../Main";

const TopContainer = styled.div``;

const Wrapper = styled.div`
  z-index: 999;
  width: 100vw;
  position: fixed;
  height: 60px;
  transition: background-color 0.3s ease-in-out;
  box-sizing: border-box;
  box-shadow: 0 0 10px 0 rgba(20, 31, 51, 0.08);
  background-color: rgba(255, 255, 255, 0.8);

  ${TopContainer} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #ededf0;

    ${p =>
      p.theme.mq({
        padding: ["0 15px", "0 50px", "0 30px", "0 30px"]
      })};
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  ${p =>
    p.theme.mq({
      width: ["100%", "100%", "auto"]
    })};
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  ${p =>
    p.theme.mq({
      width: ["100%", "100%", "auto"]
    })};
`;

const LogoLink = styled(Link)`
  height: 24px;

  display: inline-flex;
  font-size: 20px;
  line-height: 22px;
  font-family: "Dosis", "Source Sans Pro", "Helvetica Neue", Arial, sans-serif;
  font-weight: 600;
  color: #141f33;

  &.active,
  &:visited,
  &:hover {
    color: #141f33;
  }

  img {
    margin-right: 6px;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: 60px;

  &.sm {
    margin-right: 0;
  }
`;

const linkStyle = (p: any) => css`
  color: white;
  transition: border-bottom 0.2s;
  font-size: 14px;
  line-height: 16px;

  position: relative;
  top: 1px;
  height: 60px;
  padding: 20px 0;
  margin: 0 10px;
  border-bottom: 2px solid transparent;

  &.active,
  &:visited &:hover {
    color: #141f33;
    border-bottom-color: ${p => p.theme.colors.primary};
  }
`;

const MenuLink = styled(Link)`
  ${linkStyle};
  margin: 0 15px;
`;

export const IconLink = styled.a`
  ${linkStyle};
  opacity: 0.5;
  margin: 0 0 0 15px;
  border-bottom: 3px solid transparent !important;

  svg {
    stroke: ${p => p.theme.colors.main};
  }

  &:hover {
    opacity: 1;
  }
`;

interface MenuListItem {
  name: string;
  label?: string;
  [key: string]: any;
}

export const TOPBAR_LINKS: MenuListItem[] = [];

console.log(pageConfig.menu);

export const Topbar = ({ pathname }) => {
  const { width } = useWindowSize();
  const showFullMenu = width > breakpoints.tablet;
  const { showing, setShowing } = useContext(mainContext);

  const { title } = useConfig();

  return (
    <Wrapper>
      <TopContainer>
        <Left>
          <LogoLink to="/">{title}</LogoLink>
        </Left>
        <Right>
          <Menu className={showFullMenu ? "" : "sm"}>
            {showFullMenu &&
              TOPBAR_LINKS.map(({ name, label, to, ...props }) => {
                const prepath = pathname.replace(/(\/\w+)(.+)/, (m, m1) => m1);
                return (
                  <MenuLink
                    key={name}
                    className={prepath === props.to ? "active" : ""}
                    to={to || ""}
                  >
                    {label || name}
                  </MenuLink>
                );
              })}
            {!showFullMenu && (
              <Hamburguer
                opened={showing}
                onClick={() => setShowing((s: any) => !s)}
              />
            )}
          </Menu>
        </Right>
      </TopContainer>
    </Wrapper>
  );
};
